<template>
  <div class="card mb-25 border-0 rounded-0 bg-white website-visitors radius-7">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing graphic-month-dashboard-height">
      <div
        class="mb-lg-15 d-sm-flex align-items-center justify-content-between"
      >
        <h6 class="card-title fw-bold mb-0">Gravações mensais</h6>
      </div>
      <div id="websiteVisitorsChart" class="chart">
        <apexchart
          type="bar"
          height="385"
          :options="websiteVisitorsChart"
          :series="[{name: 'Quantidade',data: [{x: 'Sucesso', y: getDashboardMonthCards.total_success, fillColor: '#1D6FF2'}, {x: 'Erro', y: getDashboardMonthCards.total_error, fillColor: '#C33F52'}]}]"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "WebsiteVisitors",
  data: function () {
    return {
      websiteVisitorsChart: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            horizontal: false,
            columnWidth: "28%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#1D6FF2", "#C33F52"],
        stroke: {
          show: false,
        },
        xaxis: {
          categories: ["Sucesso", "Erro"],
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#1D6FF2", "#C33F52"],
              fontSize: "14px",
              fontWeight: 500,
            },
          },
        },
        yaxis: {
          show: true,
          tickAmount: 8,
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#607089","#C33F52"],
              fontSize: "14px",
              fontWeight: 500,
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
        grid: {
          show: true,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
      },
    };
  },
  computed:{
    ...mapGetters([
      'getDashboardMonthCards'
    ])
  },
});
</script>
